import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RoadmapStrategyHeaderIndexComponent extends Component {
  @service notifications;
  @service intl;

  @action
  copyLinkToClipboard() {
    const el = document.createElement('textarea');
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    el.setSelectionRange(0, 99999); // For mobile devices
    // Copy the text inside the text field
    navigator.clipboard.writeText(el.value);
    document.body.removeChild(el);
    this.notifications.toggleShowNotification(
      this.intl.t('roadmap.roadmap-link-copied'),
    );
  }

  @action
  updateTitle(e) {
    this.args.roadmap.set('title', e);
    this.args.scenario.set('title', `Balance - ${e}`);
    this.args.roadmap.validate();
  }
}
